<template>
  <fragment>
    <template
      v-if="getRouterChildren(item.children) && onlyOneChildren.meta.role"
    >
      <el-menu-item :index="resolvePath(onlyOneChildren.path)">
        <i :class="onlyOneChildren.meta.icon"></i>
        <span slot="title">{{ onlyOneChildren.meta.title }}</span>
      </el-menu-item>
    </template>
    <el-submenu
      v-if="!getRouterChildren(item.children) && item.meta.role"
      :index="resolvePath(item.path)"
    >
      <template slot="title">
        <i :class="item.meta.icon"></i>
        <span slot="title">{{ item.meta.title }}</span>
      </template>
      <template v-for="child in item.children">
        <el-menu-item
          :key="child.path"
          :index="resolvePath(child.path)"
          v-if="child.meta.role"
        >
          <i :class="child.meta.icon"></i>
          <span slot="title">{{ child.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-submenu>
  </fragment>
</template>
<script>
import path from "path";
import { mapGetters } from "vuex";
export default {
  name: "SideBar",
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      onlyOneChildren: ""
    };
  },
  created() {
    // console.log(this.item);
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  methods: {
    /*
     **  @description 判断路由是否无children
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getRouterChildren(children = []) {
      if (children.length === 1) {
        children.filter(item => {
          this.onlyOneChildren = item;
        });
        // if (this.menu.indexOf(this.item.children[0].name) != -1) {
        // }
        return true;
      }
      return false;
    },
    /*
     **  @description 拼接路由
     **  @param {}
     **  @return
     **  @author shipingan
     */
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    }
  }
};
</script>
<style lang="less" scoped></style>
